export enum AlgorithmEnum {
  BREADTH_FIRST_SEARCH = 1,
  DEPTH_FIRST_SEARCH,
  DJIKSTRA,
  GREEDY_ALGORITHM,
  A_STAR_ALGORITHM,
}

export enum SpeedEnum {
  SLOW = 1,
  MEDIUM,
  FAST,
}

export enum AlgorithmStatus {
  PREPARATION = 0,
  RUNNING,
  PAUSED,
  FINISHED,
}
